import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const ServiceFormStyles = styled.div`
  animation: ${fadeIn} 0.2s ease-out;

  /* ── Input container ── */
  .inputContainer {
    margin-bottom: ${({ theme }) => theme.spacing[4]};
  }

  /* ── Availability row ── */
  .availabilityRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }) => theme.spacing[16]};
    border-radius: ${({ theme }) => theme.radius[12]};
    background: ${({ theme }) => theme.colors.accent[50]};
    margin-bottom: ${({ theme }) => theme.spacing[16]};
    transition: background 0.2s ease;
  }

  .availabilityLeft {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .availabilityLabel {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .availabilityHint {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: 12px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  /* ── Submit ── */
  .buttonsContainer {
    display: flex;
    justify-content: flex-end;
    min-height: 40px;

    button {
      animation: ${slideUp} 0.25s ease-out;
    }
  }
`;
